import React, { useRef } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import "../../../scss/sticky.scss";

const Foodtable = ({ food, FoodBeverageSum }) => {
  const tableRef = useRef(null);

  return (
    <div className="flex flex-col">
      <div className="table-responsive-food">
        <div className="table-responsive-food-header">
          <div className="bg-heading-food">
            <h4 className="food-heading">Food</h4>
          </div>
          <DownloadTableExcel
            filename="foods_table"
            sheet="foods"
            currentTableRef={tableRef.current}>
            <button className="export"> Export </button>
          </DownloadTableExcel>
        </div>
        <div className="table-responsive" ref={tableRef}>
          <table className="table-food">
            <thead className="table-background">
              <tr className="sticky-header bg-white">
                <th>Group</th>
                <th>Item Name </th>
                <th>Item Rate (Rs)</th>
                <th>Quantity</th>
                <th>Total(Rs)</th>
              </tr>
            </thead>
            {!food.error &&
              food.map((item) => (
                <tr>
                  <td>{item.Description}</td>
                  <td>{item.itemName}</td>
                  <td>{item.itemrate}</td>
                  <td>{item.quantity}</td>
                  <td>{item.total}</td>
                </tr>
              ))}
          </table>
        </div>
        {FoodBeverageSum.map((item, index) => (
          <div className="flex justify-end" key={index}>
            {" "}
            <p className="font-bold text-xs p-2">
              Quantity: {item.foodquantity}
            </p>
            <p className="font-bold text-xs p-1 pt-0 mr-2">
              Total: {item.foodtotal}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Foodtable;
